var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    { key: _vm.postData.id, ref: "page", staticClass: "program post" },
    [
      _vm.layout === "suave"
        ? [_c("k-browser-content")]
        : [
            _c(
              "d-main-image",
              _vm._b(
                { on: { load: _vm.pageLoaded } },
                "d-main-image",
                { img: _vm.img, show: _vm.show },
                false
              )
            ),
            _c("k-hero"),
            _c("w-go-down"),
            _c(
              "k-main",
              { attrs: { title: _vm.title } },
              [
                _c("section", {
                  staticClass: "description",
                  domProps: { innerHTML: _vm._s(_vm.content) },
                }),
                !_vm.postData.hide_programs
                  ? _c("content-section", {
                      attrs: {
                        title: _vm.episodesTitle,
                        coming: _vm.postData.release_date,
                        "hide-coming": _vm.postData.hide_coming,
                        labels: _vm.postData.episode_labels,
                        episodes: _vm.episodes,
                      },
                    })
                  : _vm._e(),
                _c("content-section", {
                  attrs: {
                    title: _vm.archivesTitle,
                    episodes: _vm.archives,
                    labels: _vm.postData.episode_labels,
                    "show-empty": false,
                  },
                }),
                _c("comments"),
              ],
              1
            ),
            _c("div", { staticClass: "bottom-spacer" }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }